import * as R from 'ramda';

export default function ApplicationNotificationsDirectiveController(
  $window,
  $timeout,
  $scope,
  orgDataService,
  userService,
  services,
  authorizationService,
  clearNotificationsDialog,
  ssDialogService,
) {
  const vm = this;

  vm.handleServiceBundleClick = _handleServiceBundleClick;
  vm.handleAlertNotificationsBundleClick = _handleAlertNotificationsBundleClick;
  vm.handleReminderNotificationsBundleClick = _handleReminderNotificationsBundleClick;
  vm.handleInformationalNotificationsBundleClick = _handleInformationalNotificationsBundleClick;

  vm.handleNotificationClick = _handleNotificationClick;
  vm.handleDismissNotification = _handleDismissNotification;
  vm.handleClearNotificationsDialog = _handleClearNotificationsDialog;

  _activate();

  function _activate() {
    _initEventListeners();
    if (authorizationService.getToken()) {
      _refreshHasNotificationApplications();
      _refreshNotifications();
    }
  }

  function _initEventListeners() {
    $scope.$on('loggedIn', _refreshNotifications);
    $scope.$on('loggedIn', _refreshHasNotificationApplications);
    $scope.$on('refreshNotifications', _refreshNotifications);
  }

  function _refreshNotifications() {
    orgDataService.getApplicationsNotifications().then((response) => {
      vm.notificationBundles = _bundleNotifications(response.data.result);
      _checkAlertsExist();
    });
  }

  function _refreshHasNotificationApplications() {
    userService.getUser().then((user) => {
      vm.hasNotificationApplications = user.hasNotificationApplications;
    });
  }

  function _checkAlertsExist() {
    let alertsExist = false;
    R.forEach(
      (notificationBundle) => {
        if (notificationBundle.totalNotifications > 0) {
          alertsExist = true;
        }
      },
      vm.notificationBundles
    );

    vm.alertsExist = alertsExist;
  }

  function _bundleNotifications(notifications) {
    const bundledNotifications = [];
    let unacknowledgedActionItemsCount = 0;

    R.forEach(
      (service) => {
        const serviceBundle = R.clone(service);
        serviceBundle.informationalNotifications = [];
        serviceBundle.reminderNotifications = [];
        serviceBundle.alertNotifications = [];

        bundledNotifications.push(serviceBundle);
      },
      services
    );

    R.forEach(
      (notification) => {
        const serviceBundle = R.find(
          R.propEq('serviceId', notification.serviceId),
          bundledNotifications
        );
        if (notification.priorityId === 1) {
          serviceBundle.alertNotifications.push(notification);
          unacknowledgedActionItemsCount += 1;
        } else if (notification.priorityId === 2) {
          serviceBundle.reminderNotifications.push(notification);
          unacknowledgedActionItemsCount += 1;
        } else if (notification.priorityId === 3) {
          serviceBundle.informationalNotifications.push(notification);
        }
      },
      notifications
    );
    R.forEach(
      (bundle) => {
        _calculateBundleTotals(bundle);
      },
      bundledNotifications
    );

    vm.unacknowledgedActionItemsCount = unacknowledgedActionItemsCount;

    return bundledNotifications;
  }

  function _calculateBundleTotals(bundle) {
    bundle.totalNotifications = bundle.alertNotifications.length
      + bundle.reminderNotifications.length
      + bundle.informationalNotifications.length;
  }

  function _handleServiceBundleClick($event, bundle) {
    $event.stopPropagation();
    if (
      !bundle.alertNotificationsExpanded
      || !bundle.reminderNotificationsExpanded
      || !bundle.informationalNotificationsExpanded
    ) {
      bundle.alertNotificationsExpanded = true;
      bundle.reminderNotificationsExpanded = true;
      bundle.informationalNotificationsExpanded = true;
    } else {
      bundle.alertNotificationsExpanded = false;
      bundle.reminderNotificationsExpanded = false;
      bundle.informationalNotificationsExpanded = false;
    }
  }

  function _handleAlertNotificationsBundleClick($event, bundle) {
    $event.stopPropagation();
    if (
      bundle.alertNotificationsExpanded
      && !bundle.reminderNotificationsExpanded
      && !bundle.informationalNotificationsExpanded
    ) {
      bundle.alertNotificationsExpanded = false;
    } else {
      bundle.alertNotificationsExpanded = true;
      bundle.reminderNotificationsExpanded = false;
      bundle.informationalNotificationsExpanded = false;
    }
  }

  function _handleReminderNotificationsBundleClick($event, bundle) {
    $event.stopPropagation();
    if (
      !bundle.alertNotificationsExpanded
      && bundle.reminderNotificationsExpanded
      && !bundle.informationalNotificationsExpanded
    ) {
      bundle.reminderNotificationsExpanded = false;
    } else {
      bundle.alertNotificationsExpanded = false;
      bundle.reminderNotificationsExpanded = true;
      bundle.informationalNotificationsExpanded = false;
    }
  }

  function _handleInformationalNotificationsBundleClick($event, bundle) {
    $event.stopPropagation();
    if (
      !bundle.alertNotificationsExpanded
      && !bundle.reminderNotificationsExpanded
      && bundle.informationalNotificationsExpanded
    ) {
      bundle.informationalNotificationsExpanded = false;
    } else {
      bundle.alertNotificationsExpanded = false;
      bundle.reminderNotificationsExpanded = false;
      bundle.informationalNotificationsExpanded = true;
    }
  }

  function _handleNotificationClick($event, notification) {
    $event.stopPropagation();
    if (notification.externalLink) {
      $window.open(notification.externalLink);
    }
  }

  function _handleDismissNotification($event, notification) {
    $event.stopPropagation();
    orgDataService.dismissApplicationNotification(
      notification.applicationNotificationId
    ).then(() => {
      notification.isHidden = true;
      $timeout(
        () => {
          const serviceBundle = R.find(
            R.propEq('serviceId', notification.serviceId),
            vm.notificationBundles
          );

          if (notification.priorityId === 2) {
            serviceBundle.reminderNotifications = R.reject(
              R.equals(notification),
              serviceBundle.reminderNotifications
            );
          }
          if (notification.priorityId === 3) {
            serviceBundle.informationalNotifications = R.reject(
              R.equals(notification),
              serviceBundle.informationalNotifications
            );
          }
          _calculateBundleTotals(serviceBundle);
          _checkAlertsExist();
        },
        300
      );
    });
  }

  function _handleClearNotificationsDialog($event, bundle) {
    let _alertList = []

    if(bundle.reminderNotifications.length > 0){
      _alertList.push(...[...bundle.reminderNotifications])
    }
    
    if(bundle.informationalNotifications.length > 0){
      _alertList.push(...bundle.informationalNotifications)
    }
    
    ssDialogService.dialogs.global.dismissRemindersDialog = ssDialogService.alert(
      clearNotificationsDialog.getOptions($event, {
        alertList: structuredClone(_alertList)
      })
    );
    return ssDialogService.show(ssDialogService.dialogs.global.dismissRemindersDialog);
  }
}

ApplicationNotificationsDirectiveController.$inject = [
  '$window',
  '$timeout',
  '$scope',

  'orgDataService',
  'userService',
  'services',
  'authorizationService',
  'clearNotificationsDialog',
  'ssDialogService'
];
